import { useSyncExternalStore } from "react";

class AppStateHandler {
  state = {
    InApp: false,
    AppVersion: "0.0.0",
    AppEnvironment: "",
  };

  listeners = new Set();

  subscribe = (listener) => {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  };

  getSnapshot = () => {
    return this.state;
  };

  notify = () => {
    this.listeners.forEach((listener) => listener());
  };

  setAppState = (updates) => {
    const nextState = {
      ...this.state,
      ...updates,
    };

    const changed = Object.keys(updates).some(
      (key) => this.state[key] !== nextState[key]
    );

    if (!changed) {
      return;
    }

    this.state = nextState;
    this.notify();
  };

  setInAppInfo = ({ appVersion, appEnvironment }) => {
    this.setAppState({
      InApp: true,
      AppVersion: appVersion,
      AppEnvironment: appEnvironment,
    });
  };
}

export const AppStateService = new AppStateHandler();

export function useAppStateService() {
  return useSyncExternalStore(
    AppStateService.subscribe,
    AppStateService.getSnapshot,
    AppStateService.getSnapshot
  );
}